import Grid from "@mui/material/Grid";
import { ChangeEvent, useMemo, useState } from "react";
import { KeyValueObject } from "../../utils/models";
import ActionButton from "./buttons/ActionButton";
import SearchInput from "./fields/SearchInput";
import SelectField, { SelectOption } from "./fields/SelectField";

interface FilterProps {
  countryData?: KeyValueObject[];
  statusData?: KeyValueObject[];
  showCountryFilter?: boolean;
  showSearchFilter?: boolean;
  showStatusFilter?: boolean;
  showBtnSearch?: boolean;
  inputPlaceholder?: string;
  btnText?: string;
  handleOnChangeDropDown: (value: KeyValueObject | null) => void;
  onChangeSearch: (value: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleClickBtn?: () => void;
  className?: string;
}

const COLUMN_SIZE = { xs: 12, md: 4, lg: 4 };

const toOptions = (data?: KeyValueObject[]): SelectOption[] =>
  (data || []).map((item) => ({ label: String(item.value), value: item.key }));

interface FilterSelectProps {
  data?: KeyValueObject[];
  label: string;
  onChange: (value: KeyValueObject | null) => void;
}

const FilterSelect = ({ data, label, onChange }: FilterSelectProps) => {
  const options = useMemo(() => toOptions(data), [data]);
  const [selected, setSelected] = useState<string | number | null>(null);
  return (
    <SelectField
      options={options}
      value={selected}
      placeholder={label}
      emptyLabel="All"
      onChange={(value, option) => {
        setSelected(value);
        onChange(value === null || !option ? null : { key: String(option.value), value: option.label });
      }}
    />
  );
};

const Fillter = (props: FilterProps) => (
  <div className={`py-2 ${props.className ?? ""}`}>
    <Grid container spacing={2}>
      {props.showSearchFilter && (
        <Grid size={COLUMN_SIZE}>
          <SearchInput
            placeholder={props.inputPlaceholder}
            onChange={props.onChangeSearch}
            onSearch={props.handleClickBtn}
          />
        </Grid>
      )}
      {props.showCountryFilter && (
        <Grid size={COLUMN_SIZE}>
          <FilterSelect data={props.countryData} label="Country" onChange={props.handleOnChangeDropDown} />
        </Grid>
      )}
      {props.showStatusFilter && (
        <Grid size={COLUMN_SIZE}>
          <FilterSelect data={props.statusData} label="Status" onChange={props.handleOnChangeDropDown} />
        </Grid>
      )}
      {props.showBtnSearch && (
        <Grid size={COLUMN_SIZE}>
          <ActionButton appSize="large" onClick={props.handleClickBtn}>
            {props.btnText || "Search"}
          </ActionButton>
        </Grid>
      )}
    </Grid>
  </div>
);

export default Fillter;
